/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Primarystudyinterest_Study_Sociology16Inputs */

const en__field__enum_primarystudyinterest_study_sociology16 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Sociology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sociology`)
};

const de__field__enum_primarystudyinterest_study_sociology16 = /** @type {(inputs: _Field__Enum_Primarystudyinterest_Study_Sociology16Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soziologie`)
};

/**
* | output |
* | --- |
* | "Sociology" |
*
* @param {_Field__Enum_Primarystudyinterest_Study_Sociology16Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_primarystudyinterest_study_sociology16 = /** @type {((inputs?: _Field__Enum_Primarystudyinterest_Study_Sociology16Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Primarystudyinterest_Study_Sociology16Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_primarystudyinterest_study_sociology16(inputs)
	return de__field__enum_primarystudyinterest_study_sociology16(inputs)
});
export { _field__enum_primarystudyinterest_study_sociology16 as "_field__enum_primaryStudyInterest_STUDY_SOCIOLOGY" }